export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/default_img.png?55091fd105eddce913e7847077dc3c3c";